import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Clock, Loader2, Smartphone, Landmark, XCircle } from "lucide-react";
import { api, euro } from "@/lib/api";

const Bizum = ({ o }) => (
  <div className="mt-8 border-2 border-brand p-6 text-left" data-testid="order-bizum-box">
    <p className="flex items-center gap-2 font-bold text-brand"><Smartphone className="w-5 h-5" /> Paga con Bizum</p>
    <ol className="mt-4 space-y-2 text-sm list-decimal pl-5">
      <li>Envía un Bizum de <b data-testid="order-total">{euro(o.total)}</b> al <b className="text-lg" data-testid="order-bizum-phone">{o.bizum_phone}</b></li>
      <li>En el concepto escribe <b className="font-mono" data-testid="order-concept">{o.number}</b></li>
    </ol>
  </div>
);

const Transfer = ({ bank, o }) => (
  <div className="mt-8 border-2 border-brand p-6 text-left" data-testid="order-transfer-box">
    <p className="flex items-center gap-2 font-bold text-brand"><Landmark className="w-5 h-5" /> Transferencia bancaria</p>
    {bank?.iban ? (
      <div className="mt-4 space-y-1 text-sm">
        <p>Importe: <b>{euro(o.total)}</b></p>
        <p>IBAN: <b className="font-mono" data-testid="order-iban">{bank.iban}</b></p>
        <p>Titular: <b data-testid="order-holder">{bank.holder}</b></p>
        <p>Concepto: <b className="font-mono">{o.number}</b></p>
      </div>
    ) : <p className="mt-3 text-sm">En breve te enviaremos por email los datos de la cuenta para hacer la transferencia.</p>}
  </div>
);

export default function OrderPlaced() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/orders/${id}/summary`).then((r) => setO(r.data)).catch(() => setErr(true)); }, [id]);

  if (err) return <div className="py-32 text-center" data-testid="order-placed-error"><XCircle className="w-12 h-12 mx-auto text-rose-500" /><p className="mt-4">Pedido no encontrado.</p></div>;
  if (!o) return <div className="py-32 text-center"><Loader2 className="w-10 h-10 mx-auto animate-spin text-brand" /></div>;
  const paid = o.status !== "pendiente_pago";

  return (
    <div className="mx-auto max-w-lg px-6 py-24 text-center" data-testid="order-placed-page">
      <h1 className="font-heading text-4xl font-black uppercase tracking-tight">{o.status === "cancelado" ? "Pedido cancelado" : "¡Pedido recibido!"}</h1>
      <p className="mt-3 text-slate-600">Pedido <b className="font-mono" data-testid="order-number">{o.number}</b> · {euro(o.total)}</p>
      {o.status === "cancelado" ? <p className="mt-8 text-rose-600 font-semibold" data-testid="order-cancelled">Este pedido está cancelado.</p>
        : paid ? <p className="mt-8 text-emerald-600 font-semibold" data-testid="order-paid">Pago recibido. ¡Ya estamos preparando tu pedido!</p>
        : <>
          {o.payment_method === "bizum" ? <Bizum o={o} /> : <Transfer bank={o.bank} o={o} />}
          <p className="mt-6 flex items-start gap-2 text-left text-sm text-slate-600"><Clock className="w-4 h-4 mt-0.5 shrink-0" />
            Te reservamos los artículos {o.reserve_hours} horas. Cuando recibamos el pago te enviaremos la confirmación por email y prepararemos el envío.</p>
          <p className="mt-2 text-left text-xs text-slate-500">También te lo hemos enviado por email.</p>
        </>}
      <div className="mt-10 flex justify-center gap-3">
        <Link to="/tienda" className="btn-primary" data-testid="order-continue">Seguir comprando</Link>
        <Link to="/cuenta" className="btn-outline" data-testid="order-my-orders">Mis pedidos</Link>
      </div>
    </div>
  );
}
